module.exports = __webpack_public_path__ + "img/ia-02-4.60964a86.jpg";